import {Injectable} from '@angular/core';
import {Workbook} from 'exceljs';
import * as fs from 'file-saver';
import {TranslateService} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {GetLanguage, setMomentLocal} from "../shared/functions/shared-functions";
import {secureStorage} from "../shared/functions/secure-storage";
import {environment} from "../../environments/environment";
import {momentDateFormat} from "../shared/variables/variables";
import {PageTitleService} from "../core/components/page-title/page-title.service";
import {Title} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class ExcelService {


  constructor(private datePipe: DatePipe, private translateService: TranslateService, private pageTitleService: PageTitleService) {

  }

  generateExcel(data, values, header?) {
    setMomentLocal();
    const translatedTitle = this.pageTitleService.getTitle();
    const customHeaders = [...header];
    const customValues = [...values];
    const prepare = [];
    data.forEach(e => {
      const row = [];
      console.log('e', e)
      customValues.forEach((value, index) => {
        console.log('e[value]', e[value])
        row.push(e[value]?.toString() || ' - ');
      });
      prepare.push(row);
    });
    data = prepare;
    console.log('prepare', prepare)
    this.translateService.get(customHeaders).subscribe(async res => {
      // @ts-ignore
      header = Object.values(res);
      // Create workbook and worksheet
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(translatedTitle, {views: [{rightToLeft: GetLanguage() === 'ar'}]});

      // Add Image
      const imageUrl = environment.mainLogo
      const imageBytes = await fetch(imageUrl).then(response => response.arrayBuffer());
      let logo = workbook.addImage({
        // base64: logoFile.logoBase64,
        extension: 'png',
        buffer: imageBytes
      });
      worksheet.addImage(logo, 'B2:B5');
      worksheet.mergeCells('B1:B5');


      // Add Row and formatting
      worksheet.addRow([]);
      const date = GetLanguage() === 'ar' ? 'التاريخ : ' : 'Date : ';
      const subTitleRow = worksheet.addRow([date + momentDateFormat(new Date())])
      subTitleRow.font = {name: 'Comic Sans MS', family: 4, size: 17, underline: 'none', bold: false}


      // Blank Row
      worksheet.addRow([]);

      // Add Header Row
      const headerRow = worksheet.addRow(header);
      headerRow.font = {family: 4, size: 14, underline: 'none', bold: true}

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: '0c35f8'},
          bgColor: {argb: '0c35f8'}
        }
        cell.border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}}
        cell.font = {color: {argb: 'FFFFFF'}, family: 4, size: 14, underline: 'none', bold: true}
      })
      // worksheet.addRows(data);


      // Add Data and Conditional Formatting
      data.forEach(d => {
          // d[d.length - 1] = null;
          const row = worksheet.addRow(d);
          row.font = {size: 16, family: 4, underline: 'none', bold: false};
          row.alignment = {horizontal: GetLanguage() === 'ar' ? 'right' : 'left'}

        }
      );

      // worksheet.getColumn(3).width = 30;
      // worksheet.getColumn(4).width = 30;
      // worksheet.addRow([]);

      worksheet.columns.forEach(column => {
        // const lengths = column.values.map(v => v?.toString().length);
        // const maxLength = Math.max(...lengths?.filter(v => typeof v === 'number')) + 5;
        // column.width = maxLength < 10 ? 10 : maxLength;
        column.width = 30;
      });
      // Footer Row
      // // let footerRow = worksheet.addRow(['This is system generated excel sheet.']);
      // // footerRow.getCell(1).fill = {
      // //     type: 'pattern',
      // //     pattern: 'solid',
      // //     fgColor: {argb: 'FFCCFFE5'}
      // // };
      // footerRow.getCell(1).border = {top: {style: 'thin'}, left: {style: 'thin'}, bottom: {style: 'thin'}, right: {style: 'thin'}}
      //
      // //Merge Cells
      // worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

      // Generate Excel File with given name
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        fs.saveAs(blob, `${translatedTitle}-${momentDateFormat(new Date())}.xlsx`);
      })
    });
  }
}
